module.exports = __webpack_public_path__ + "media/connect_intcable.90666cea.mp4";